var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DameraDetailInfo"},_vm._l((_vm.videoData),function(item,index){return (_vm.videoData.length)?_c('DetailsShow',{key:index,attrs:{"data":item}}):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }